<template>
    <el-dialog
        title="Move to"
        custom-class="dialog-move-file"
        closeable
        :visible.sync="value"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="$emit('input', false)"
        width="50%"
    >
        <div class="file-paths">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <a @click="onDirClick(null)">All Files</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item
                    v-for="(path,index) in curDirPaths"
                    :key="index"
                >
                    <a @click="onDirClick(path)">{{ path.name }}</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="curDir.id">{{ curDir.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="file-list" v-if="dataList.length">
            <a class="file-item" v-for="(d, index) in dataList" :key="d.id" @click="onDirClick(d)">
                <img :src="d.icon" class="file-item__icon" alt="">
                <span class="file-item__name">{{ d.name }}</span>
            </a>
        </div>
        <div class="file-empty" v-else>
            <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAAflBMVEUAAAD/137/zF3/7sv/7sz/8Mz/78z/ylj/78z/1Xv/8Mz/8tH/8MH/1n3/133/7sv/7sz/1X7/78z/1X7/78z/1X7/13//78z/1oD/3YP/14D/8sv/1oD/887/xUn+1X3/7sv/14H+x03/z2f+1Hf+yFL+zWD+0nL+0G3+yliWAl5hAAAAHnRSTlMAbf33xUH7+5aTWiYI9vLx5N3bxK+shXxkSkA7MhWzZ/O0AAABAUlEQVRYw+3TWW6DQBBFUQJ4SOzM8/Tc6QnY/wazATdYtO5f3QUclUp6jWVZlkW16TtXavu0P1TIbr7uZjXdu6U2a+lukX44rqTdcu8cff+L0W7P0dsDRrsXjnbfHN1ztFuzyb/Lurs628fPDK0LC6fzvR6raX8q9FZNKxfox3rax4JdT6vlaA0cPXG0Ro5OHK3A0Z6jFTjaR4xW5mhFjp44WgNHJ47WyNGJoxU42nO0Mkf7iNFqOVoDR08crZGjE0crcLTnaAWO9hGjlTlakaMnjtbA0YmjNXJ04mgFjvYcrTxD+8qz422R3qmu8Fykr2vpr6Zs72p+0n42lmVZFtQ/4NqoU3Oa6doAAAAASUVORK5CYII=">
            <div>Move to {{ curDir.name }}</div>
        </div>
        <div slot="footer">
            <el-button size="medium" @click="$emit('input', false)">Cancel</el-button>
            <el-button size="medium" type="primary" @click="onMove">Move to here</el-button>
        </div>
    </el-dialog>
</template>

<script>
import ApiService from "../utils/ApiService";

export default {
    name: "DialogMoveToDir",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataList: [],
            loading: true,
            dir: 0,
            curDir: {},
            curDirPaths: {}
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.dir = 0;
                this.fetchList();
            }
        },
    },
    methods: {
        fetchList() {
            this.loading = true;
            ApiService.get('/buildium/reports/dirs', {
                params: {
                    dir: this.dir,
                    orderby: 'name',
                    order: 'asc'
                }
            }).then(response => {
                this.dataList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchDir() {
            ApiService.get('/buildium/reports/dirs/' + this.dir).then(response => {
                this.curDir = response.data.dir;
                this.curDirPaths = response.data.paths;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        onDirClick(d) {
            if (d) {
                this.dir = d.id;
                this.fetchDir();
                this.fetchList();
            } else {
                this.dir = 0;
                this.fetchList();
                this.curDirPaths = [];
                this.curDir = {};
            }
        },
        onDirUp() {
            this.curDir = this.curDir.parent;
            this.fetchList();
        },
        onMove() {
            this.$emit('input', false);
            this.$emit('move', this.dir);
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>